import { FC, ReactNode } from 'react';

import { PlatformCheckoutDialog } from 'src/components/platform-checkout';

import { BillingCheckoutContext } from './billing-checkout-context';
import { useCheckoutSession } from './use-checkout-session';

// ----------------------------------------------------------------------

/**
 * Owns the single provider-hosted checkout dialog, so the billing page, the
 * payment banner and the hard paywall all trigger the very same flow.
 */
export const BillingCheckoutProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const contextValue = useCheckoutSession();

  return (
    <BillingCheckoutContext.Provider value={contextValue}>
      {children}
      <PlatformCheckoutDialog />
    </BillingCheckoutContext.Provider>
  );
};
